import { render, staticRenderFns } from "./InstanceItem.vue?vue&type=template&id=3f87a82c&scoped=true"
import script from "./InstanceItem.vue?vue&type=script&lang=js"
export * from "./InstanceItem.vue?vue&type=script&lang=js"
import style0 from "./InstanceItem.vue?vue&type=style&index=0&id=3f87a82c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f87a82c",
  null
  
)

export default component.exports